import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState, AppThunk } from '../../app/store';
import { KPIExtraReducer } from './kpiThunk';

export interface State {
    isEnquiring: boolean,
    loadingKPI: boolean,
    loadingPinned: boolean,
    kpiData: any[],
    pinnedKPI: any[],
    generatedKpiResponse?: any,
    kpi: any,
}

const initialState: State = {
    kpiData: [],
    pinnedKPI: [],
    isEnquiring: false,
    loadingKPI: false,
    loadingPinned: false,
    generatedKpiResponse: {},
    kpi: {},
};

export const kpiSlice = createSlice({
    name: 'kpi',
    initialState,
    reducers: {
        addKPI: (state, action: PayloadAction<any>) => { state.kpiData.push(action.payload) },
        setKPI: (state, action: PayloadAction<any[]>) => { state.kpiData = action.payload }
    },
    extraReducers: (builder) => {
        KPIExtraReducer(builder);
    }
});

export const { addKPI, setKPI } = kpiSlice.actions;

export const selectIsEnquiring = (state: RootState) => state.kpi.isEnquiring;
export const selectKPI = (state: RootState) => state.kpi.kpiData;

export default kpiSlice.reducer;
